import { useTranslation } from 'react-i18next';

import Toggle from 'components/desktop/_general/Toggle/Toggle';
import * as CharacteristicToggle from 'types/_general/Search/CharacteristicToggle';
import * as CharacteristicToggleList from 'types/_general/Search/CharacteristicToggleList';

interface IProps {
	all: CharacteristicToggleList.Type;
	handleChange: (input: { saved: string; all: string[] }) => void;
	saved: string[];
}

const CharacteristicToggleSelectNew = (props: IProps) => {
	const { t } = useTranslation();

	const renderToggle = (toggle: CharacteristicToggle.Type): JSX.Element => {
		return (
			<Toggle
				checked={props.saved.length === 0 || props.saved.includes(toggle.id)}
				elementId={toggle.id}
				handleToggle={() =>
					props.handleChange({
						saved: toggle.id,
						all: CharacteristicToggleList.mapToStringList(props.all),
					})
				}
				label={`characteristic:${toggle.name}`}
			/>
		);
	};

	return (
		<div>
			<label>{t('_general:CHARACTERISTIC')}</label>
			{props.all.map((e: CharacteristicToggle.Type, i: number) => {
				return (
					<div key={i} className="mt-1">
						{renderToggle(e)}
					</div>
				);
			})}
		</div>
	);
};

export default CharacteristicToggleSelectNew;
